import { ConfirmActionModal } from 'components/ui/modal';
import React from 'react';
import { withTranslation } from 'react-i18next';

function ConfirmAssignCarrierModal({
  t,
  isOpen,
  onClose,
  onConfirm,
  shipment,
  brokerCarrierDriver,
}) {
  function confirmAssignment() {
    onConfirm(shipment, brokerCarrierDriver);
    onClose();
  }

  return (
    <ConfirmActionModal
      className="w-4/5"
      isOpen={isOpen}
      title={t('ASSIGN')}
      onConfirm={confirmAssignment}
      onClose={onClose}
    >
      <div>{t('ASSIGN_BROKER_CARRIER_WARNING_MESSAGE')}</div>
    </ConfirmActionModal>
  );
}

export default withTranslation()(ConfirmAssignCarrierModal);
